<template>
  <div id="mobile-col2-container">
    <SummaryTable class="mb-4" />
    <TTReader panel="sidebarBot" />
  </div>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import TTReader from '@/components/TipTap/wrappers/TTReader.vue'
import SummaryTable from '@/components/public/SummaryTable/SummaryTable.vue'

const components = {
  TTReader, SummaryTable,
}

@Component({ components })
export default class MobileCol2 extends Vue {}

</script>

<style>

#mobile-col2-container .summary-table-container .table {
  color: inherit;
}

</style>
